import {AssociationBattleProps} from './types'
import TopList from './TopList'
import TopListHeader from './TopListHeader'
import {useEffect, useState} from 'react'
import * as React from 'react'
import {ToplistItem} from '../Shared/Services/Campaign/interfaces'
import CampaignService from '../Shared/Services/Campaign'
import {filter, includes} from 'lodash'
import {StatusCode} from '../Shared/Services/Response.types'
import {mapCountyFromMaps} from './utils'
import LoadingIndicator from '../Shared/Components/LoadingIndicator'
import {IndicatorTheme} from '@sharedComponents/LoadingIndicator/types'
import {GetCustomerSessionContext, GetUserSessionContext} from "@apps/Shared/Utils/ContextHelper";
import map from "lodash/map";
import './Scss/association-battle.scss'
import {County} from "@apps/Shared/Types/County";

const AssociationBattle = (props: AssociationBattleProps) => {

    const [loading, setLoading] = useState<boolean>(true)
    const [loadingTopList, setLoadingTopList] = useState<boolean>(false)
    const [topList, setTopList] = useState<ToplistItem[]>([])
    const [filteredTopList, setFilteredTopList] = useState<ToplistItem[]>([])
    const [filteredTopListCounty, setFilteredTopListCounty] = useState<
        ToplistItem[]
    >([])
    const [year, setYear] = useState<string>(
        new Date().getFullYear().toString()
    )
    const [county, setCounty] = useState<County>(County.All)
    const [search, setSearch] = useState<string>('')
    const isSearched = search ? true : false
    const userContext = GetUserSessionContext();
    const isLoggedIn =
        userContext &&
        userContext.User &&
        userContext.User.id
    const customerContext = GetCustomerSessionContext();
    const userCompanies = customerContext?.Customers || []
    const userCompanyIds = map(userCompanies, 'id')

    const ownItems = isLoggedIn
        ? filter(topList, item => {
            return includes(userCompanyIds, item.id)
        })
        : []


    async function getTopLists() {
        const response = await fetchAssociationToplist(year).catch();
        setTopList(response || []);
        return response || [];
    }

    const fetchAssociationToplist = async (year: string) => {
        return new Promise<ToplistItem[]>((resolve, reject) => {
            let response: ToplistItem[] = [];
            CampaignService.GetAssociationToplist(year)
                .then((result) => {
                    if (result.status === StatusCode.OK) {
                        response = result.data;
                        if (!response) {
                            return reject();
                        }
                        return resolve(response);
                    } else {
                        const errorMessages = result.data.message;
                        console.log(errorMessages);
                        setLoading(false);
                        setLoadingTopList(false);
                        return reject();
                    }
                })
                .catch((error: any) => {
                    console.log(error);
                    setLoading(false);
                    setLoadingTopList(false);
                    return reject();
                })
        })
    }

    const filterToplist = async (
        searchTerm: string,
        topListItems: ToplistItem[],
        county: County
    ) => {
        const toLower = <T extends string>(x: T) => x.toLowerCase() as Lowercase<T>;
        if (searchTerm && searchTerm != '') {
            const searchTermLower = searchTerm.toLowerCase();
            if (county === County.All) {
                const filtered = filter(
                    topListItems,
                    item =>
                        includes(item.city.toLowerCase(), searchTermLower) ||
                        includes(item.county.toLowerCase(), searchTermLower) ||
                        includes(
                            item.municipality.toLowerCase(),
                            searchTermLower
                        ) ||
                        includes(item.name.toLowerCase(), searchTermLower)
                );
                filtered.sort((a, b) => a.position - b.position);
                setFilteredTopList(filtered || []);
            } else {
                const onlyInCounty = filter(topListItems, (item) =>
                    includes(item.county.toLowerCase(), toLower(county))
                );
                const filtered: ToplistItem[] = filter(
                    onlyInCounty,
                    (item: ToplistItem) =>
                        includes(item.city.toLowerCase(), searchTermLower) ||
                        includes(item.county.toLowerCase(), searchTermLower) ||
                        includes(
                            item.municipality.toLowerCase(),
                            searchTermLower
                        ) ||
                        includes(item.name.toLowerCase(), searchTermLower)
                );
                filtered.sort((a: ToplistItem, b: ToplistItem) => a.positionCounty - b.positionCounty);
                setFilteredTopListCounty(filtered || []);
            }
        } else {
            if (county === County.All) {
                topListItems.sort((a, b) => a.position - b.position);
                setFilteredTopList(topListItems || []);
            } else {
                const filtered = filter(topListItems, (item) =>
                    includes(item.county.toLowerCase(), toLower(county))
                );
                filtered.sort((a: ToplistItem, b: ToplistItem) => a.positionCounty - b.positionCounty);
                setFilteredTopListCounty(filtered || []);
            }
        }
    }

    async function getCounty() {
        const geocoder = new google.maps.Geocoder();

        const latlng = await getCoords().catch();
        const countyName = await getCountyFromGeocoder(geocoder, latlng).catch();
        const selectedCounty = mapCountyFromMaps(countyName);
        setCounty(selectedCounty);
        return selectedCounty;
    }

    const getCoords = () => {
        return new Promise<any>(resolve => {
            const latlng = {
                lat: 0,
                lng: 0,
            }

            if (navigator && navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    pos => {
                        ;(latlng.lat = pos.coords.latitude),
                            (latlng.lng = pos.coords.longitude)
                        resolve(latlng);
                    },
                    f => {
                        resolve(latlng);
                    }
                )
            } else {
                resolve(latlng);
            }
        })
    }
    const getCountyFromGeocoder = (
        coder: google.maps.Geocoder,
        latlng: any
    ) => {
        return new Promise<string>(resolve => {
            const geocoder = coder;
            geocoder.geocode({location: latlng}, function (results, status) {
                // Checks if long_name ends with whitespace + l*n
                const regex = new RegExp('\\s+[l-lL-L]+.+[n-nN-N]+$');
                if (
                    status == google.maps.GeocoderStatus.OK && results &&
                    results[0].address_components.some(address =>
                        regex.test(address.long_name)
                    )
                ) {
                    results[0].address_components.forEach(address => {
                        if (address.long_name.match(regex)) {
                            resolve(address.long_name);
                        }
                    })
                } else {
                    resolve('All');
                }
            })
        })
    }

    const initialize = async () => {
        setLoading(true);
        const initialCounty = await getCounty().catch();
        const initialToplist = await getTopLists().catch();
        await filterToplist(search, initialToplist, initialCounty);
        setLoading(false);
    }

    const filterToplistOnYear = async () => {
        setLoadingTopList(true);
        const toplist = await getTopLists().catch();
        filterToplist(search, toplist, county);
        setLoadingTopList(false);
    }

    const onSearch = (searchTerm: string) => {
        setSearch(searchTerm);
        filterToplist(searchTerm, topList, county);
    }

    useEffect(() => {
        initialize().catch(() =>
            console.info('Something went wrong when initializing toplist')
        )
    }, []);

    useEffect(() => {
        filterToplist(search, topList, county).catch()
    }, [county]);

    useEffect(() => {
        filterToplistOnYear().catch(() =>
            console.info('Something went wrong when filtering toplist')
        )
    }, [year]);

    return (
        <>{loading ? (
                <LoadingIndicator customMargins="5rem 0"/>
            ) :
            (
                <div className={`association-battle ${props.wideLayout ? 'association-battle--wide' : ''}`}>
                    <TopListHeader
                        onSearch={onSearch}
                        heading={props.heading}
                        onCountyChange={setCounty}
                        initialCounty={county}
                        onYearChange={setYear}
                    />
                    {loadingTopList ? (
                        <LoadingIndicator
                            customMargins="5rem 0"
                            theme={IndicatorTheme.DarkMode}
                        />
                    ) : (
                        <TopList
                            ownItems={ownItems}
                            items={
                                county === County.All
                                    ? filteredTopList
                                    : filteredTopListCounty
                            }
                            isSearched={isSearched}
                            useGlobalTopList={county === County.All}
                        />
                    )}
                </div>
            )}
        </>
    )
}

export default AssociationBattle